import { communicationStore } from '@yoop/whitelabel-manager-store';
import { apiClientStore } from '@yoop/whitelabel-api-client';
import { CommsMessageActions } from '@yoop/whitelabel-data';

export const onRevokeToken = async (tokenId: string, requestKey: string) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      if (!apiClient) {
        throw new Error('Cannot revoke token: API client is not initialized.');
      }
      await apiClient.tokenController.revokeToken(tokenId);
    },
  });
};

export const onResendTokenInvite = async (assignmentId: string, requestKey: string) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      if (!apiClient) {
        throw new Error('Cannot resend token invite: API client is not initialized.');
      }
      await apiClient.tokenController.resendInvite(assignmentId);
    },
  });
};

export const onReturnToken = async (tokenId: string, requestKey: string) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      if (!apiClient) {
        throw new Error('Cannot return token: API client is not initialized.');
      }
      await apiClient.tokenController.returnToken(tokenId);
    },
  });
};

export const onAssignTokenToCurrentUser = async (
  // Optional because its only caller (the whitelabel-manager comms router) has no event id to
  // give: CommsMessageActions.AssignTokenToCurrentUser carries EventTokenActionData, which holds
  // only a tokenId. See the guard below.
  eventId: string | undefined,
  tokenId: string,
  requestKey: string,
) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      if (!apiClient) {
        throw new Error('Cannot assign token: API client is not initialized.');
      }
      // selfAssignToken interpolates the id straight into the query string, so without this the
      // request went out as `globalEventId=undefined`. Fail before the call instead: the backend
      // rejected it anyway, so the caller still sees an error, just an accurate one.
      if (!eventId) {
        throw new Error('Cannot assign token: no event id was provided.');
      }
      await apiClient.tokenController.selfAssignToken(eventId, tokenId);
    },
  });
};
